"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Login',
  data: function data() {
    var validateID = function validateID(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('IDを入力してください'));
      } else {
        callback();
      }
      /*
      if (1) {
        callback(new Error('メールアドレスを正しく入力してください'))
      } else {
        callback()
      }
      */
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 1) {
        callback(new Error('パスワードを入力してください'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        id: '',
        password: ''
      },
      loginRules: {
        id: [{
          required: true,
          trigger: 'blur',
          validator: validateID
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      otherQuery: {},
      errorAlert: '',
      errorShow: false
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted: function mounted() {
    if (this.loginForm.id === '') {
      this.$refs.id.focus();
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus();
    }
  },
  destroyed: function destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock: function checkCapslock(e) {
      var key = e.key;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    showPwd: function showPwd() {
      var _this = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this2 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          _this2.$store.dispatch('auth/login', _this2.loginForm).then(function () {
            // alert('login')
            // alert(this.redirect || '/')
            _this2.$router.push({
              path: _this2.redirect || '/',
              query: _this2.otherQuery
            });
            _this2.loading = false;
          }).catch(function (error) {
            console.log(error);
            _this2.errorShow = error !== '';
            _this2.errorAlert = error;
            _this2.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
  }
};